// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { t } from "@lingui/macro"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { grpc } from "../../../app/rpc/executor"
import { narratePreferencesClient } from "../../../app/rpc/client"
import { showSnackBar } from "../../snackbar/actions"
import { Empty } from "google-protobuf/google/protobuf/empty_pb"
import { NarratePreferences } from "../../../generated/wisetime/user/assistant/v4/preferences_pb"

type GetNarratePreferencesRpc = () => Observable<NarratePreferences>

export const getSavedNarratePreferences = (getNarratePreferencesRpc: GetNarratePreferencesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.getSavedNarratePreferences.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(getNarratePreferencesRpc),
        map(t => t.toObject()),
        map(Slice.setSavedNarratePreferences),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_get_narrate_preferences_failed",
            message: "Failed to load narrate preferences. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const getNarratePreferencesRpc = (): Observable<NarratePreferences> =>
  grpc(() => narratePreferencesClient.getNarratePreferences(new Empty(), null))

export default getSavedNarratePreferences(getNarratePreferencesRpc)
